import { useState, useCallback } from 'react';
import { isIE11Browser } from '@Utils/commonUtils';
import { getFullTrace, LOG_TYPE, addLog } from '@Service/loggingService';

export const useCopySupportLogs = (error, errorInfo) => {
    const [isCopying, setIsCopying] = useState(false);

    const [logText, setLogText] = useState('');

    if (error) {
        addLog(LOG_TYPE.ERROR, 'CopyLogButton.error', error.toString());
        addLog(LOG_TYPE.ERROR, 'CopyLogButton.error', errorInfo.componentStack);
    }
    const getTrace = useCallback(() => {
        setLogText(getFullTrace());
    }, []);

    // For some reason react-copy-to-clipboard fails for the 32bit version of MSWord 365 installed on a Windows PC
    // The 'ieCopy' method below ensures that the log text is copied to clipboard for this specific version.
    // Interestingly the window.clipboardData.setData method is only available in the 32bit version, therefore we
    // need the try/catch below to handle the 64bit version of MSWord 365 on a Windows PC.
    // All other variants: MSWord Online for Mac and Windows and the installed version of MSWord for Mac will continue to use react-copy-to-clipboard
    const ieCopy = useCallback(() => {
        try {
            if (isIE11Browser()) {
                window.clipboardData.setData('Text', getFullTrace());
                setIsCopying(false);
            }
        } catch (err) {
            addLog(LOG_TYPE.ERROR, 'CopyLogButton.ieCopy', err);
        }
    }, []);

    return { isCopying, setIsCopying, logText, getTrace, ieCopy };
};
